// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3xvxH","gfeWrapper":"CalendarEvent_gfeWrapper__XH0Bt"};